import './ProductExtraBadge.less';
import React, {useState, useEffect} from 'react';
import ImageView from "../image-view/ImageView";
import __ from '../../../i18n';
import Popup from '../../../components/popup/Popup';
import ProductExtraBrowseTool
    from '../../tools/product-extra-browse/ProductExtraBrowseTool';
import Request from '../../../api/Request';
import conditionLevels from '../../../model-constants/product/conditionLevels';
import Products from "../../../models/product/Products";

const defaultData = {
    extra: null,
    images: [],
};

export default function ProductExtraBadge({
    initialExtraId = null,
    productClassType,
    ProductExtraListParcel,
    browseButtonText,
    browseToolTitle,
    onBrowsingEnd = () => {},
    onChange = () => {},
    onLoadedEmpty = () => {},
}) {

    const [pickerShown, setPickerShown] = useState(false);

    const [data, setData] = useState(defaultData);

    useEffect(() => {
        if (data !== defaultData) {
            onChange(data.extra, data.images);
        }
    }, [data]);

    const getParcel = () => {
        return new ProductExtraListParcel(
            {
                extraIds: initialExtraId !== null ? [initialExtraId] : [],
                publishedOnly: false
            },
            [['priority', false], ['publish_time', false]],
            0,
            1
        );
    };

    useEffect(() => {
        if (data.extra !== null && initialExtraId === data.extra.id) {
            return;
        }

        let onSuccess = data => {
            if (data.items.length === 0) {
                setData(defaultData);
                onLoadedEmpty();
                return;
            }

            setData({
                extra: data.items[0],
                images: data.relations.image
            });
        };

        let onError = error => {
            setData(defaultData);
            onLoadedEmpty();
        };

        Request.add(getParcel())
            .then(data => onSuccess && onSuccess(data))
            .catch(error => onError && onError(error));

        return () => {
            onSuccess = null;
            onError = null;
        };

    }, [initialExtraId]);

    if (data.extra === null) {
        return null;
    }

    return <div className="product-extra-badge">
        <div className="main-row">
            <ImageView
                image={data.images.find(t => t.id === data.extra.avatar_image_id)}
                ratio={1}
            />
            <div className="lines">
                <div className="name">
                    <a
                        href={Products.createUrl(data.extra.slug, data.extra.product_option_id)}
                        title={__('Open in new tab')}
                        target="_blank"
                    >{data.extra.name}</a>
                </div>
                <div className="tags">
                    <div className="tag">
                        {conditionLevels.get(data.extra.condition_level).label}
                    </div>
                </div>
                <div className="price">
                    {
                        data.extra.is_price_public
                            ? __(':price(CURRENCY)', {price: data.extra.sale_price})
                            : __('Contact for price')
                    }
                </div>
            </div>
        </div>
        <div className="picker-pad" onClick={() => setPickerShown(true)}>
            {browseButtonText}
        </div>
        {
            pickerShown &&
            <Popup>
                <ProductExtraBrowseTool
                    title={browseToolTitle}
                    productClassType={productClassType}
                    ProductExtraListParcel={ProductExtraListParcel}
                    defaultValue={data.extra}
                    onChange={(extra, images) => {
                        onBrowsingEnd();
                        setData({extra, images});
                        setPickerShown(false);
                    }}
                    onCancel={() => setPickerShown(false)}
                />
            </Popup>
        }
    </div>;
}
